import ButtonComponent from "../../../components/common/button/Button";
import Modal from "../../../components/common/modal/Modal";
import "../../LT/analyticsresults/ViewAllDetails.css";

const NotAllowedModal = ({ openNotAllowedModal, handleCloseNotAllowedModal, response }) => {

    const handleClose = (e) => {
        handleCloseNotAllowedModal();
    }

    return (
        <div>
            <Modal
                className="LeadTimeModal_cls"
                open={openNotAllowedModal}
                handleClose={handleClose}
                title="Ticket Creation-Not Allowed"
                action={
                    <NotAllowedFooter
                        className="viewAllDetails_cls"
                        handleCloseModal={handleClose}
                    />
                }
                content={
                    <NotAllowedContent response={response} />
                }
            />
        </div>
    )
}
export default NotAllowedModal;

const NotAllowedFooter = ({ handleCloseModal }) => {

    return (
        <div className='button-alignment'>
            <ButtonComponent
                maxWidth="170px"
                label="Close"
                type="secondary"
                onClick={handleCloseModal}
            />
        </div>
    )
}

const NotAllowedContent = ({ response }) => {

    return (

        <div style={{ width: 700, height: 100 }}>
            <p >{response?.s4TicketNotAllowedMessage}</p>
        </div>

    )
}